var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rm por"},[_c('div',{staticClass:"rm-warehouse"},[_c('Table',{attrs:{"size":"small","max-height":"200","columns":_vm.columns,"border":"","noDataText":"暂无仓库地址!","data":_vm.warehouseVOS}})],1),_c('div',{attrs:{"id":"regionMapContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }